import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { Error, GetCustomScriptList } from '@eggplant/types'
import type { Params } from '@eggplant/data-request/src/lib/components/types'
import type { ReactElement } from 'react'

export interface Props {
  params: any[] | Params | undefined
  children: () => ReactElement
  onSuccess?: (data: GetCustomScriptList) => void
  onError?: (error: Error) => void
}

const GetCustomScriptListRequest = ({
  params,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = TEST_CONFIG_SERVICE + '/custom_scripts'

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetCustomScriptListRequest
